import Vue from 'formVueLp2';

new Vue({
  el: '.l-wrapper',
  data() {
    return {
      isModalLeavingActive: false,
      dummyViewState: 'dummy_view',
    }
  },
  created() {
    if (this.isHistorySupported()) {
      window.addEventListener('popstate', this.popstateCallback);
      history.replaceState({page: this.dummyViewState}, null, null);
      history.pushState(null, null, null);
    }
  },
  methods: {
    popstateCallback(e) {
      // 初期ロード時、意図していないState時、CTAクリックによるページ遷移時は無効
      if (!this.hasDummyState(e) || location.hash) {
        return;
      }
      this.isModalLeavingActive = !this.isModalLeavingActive;
    },
    isHistorySupported() {
      return typeof history !== 'undefined' && typeof history.pushState !== 'undefined' && typeof history.state !== 'undefined';
    },
    hasDummyState(e) {
      return this.hasState(e) && this.hasPageState(e);
    },
    /** stateが登録されているかどうか確認 */
    hasState(e) {
      return typeof e.state !== 'undefined' && e.state !== null;
    },
    /** 意図しているstateが登録されているかどうか確認 */
    hasPageState(e) {
      return typeof e.state.page !== 'undefined' && e.state.page === this.dummyViewState;
    },
    closeModalForLeaving() {
      this.isModalLeavingActive = false;
    },
  }
});
